import React, { useState, useEffect } from 'react';
import back from "~/assets/images/arrow.svg";
import HeaderDesktop from "~/components/layout/Header";
import SideBar from "~/components/layout/Sidebar";
import VisitDetailsModal from '~/components/VisitDetailsModal';
import VisitConfirmationModal from '../../components/VisitConfirmationModal';
import VisitValidationModal from '../../components/VisitValidationModal';
import VisitNotConfirmedModal from '~/components/VisitNotConfirmedModal';
import FeedbackModal from '../../components/FeedbackModal';
import ResponseRegisteredModal from '~/components/ResponseRegisteredModal';
import ConsultantRatingModal from '../../components/ConsultantRatingModal';
import commitmentService from '~/services/commitmentService';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import HeaderMobile from '~/components/layout/HeaderOld';
import Loading from '~/components/layout/Loading';
import { mask } from '~/utils/formatters/phoneFormatter';
import accountOutline from '../../assets/images/account-outline.svg';
import dateSvg from '../../assets/images/date.svg';
import emailSvg from '../../assets/images/email.svg';
import eyesSvg from '../../assets/images/eyes.svg';
import foneSvg from '../../assets/images/fone.svg';
import starSvg from '../../assets/images/star.svg';
import informationCicle from '../../assets/images/information-circle.svg';

import { useVisitModals, useVisitFilters, useVisitData, useDateUtilities } from './hooks';

import {
  MobileContainer,
  MobileContent,
  MobileExpandableContent,
  MobileSectionHeader,
  MobileSectionHeaderTitle,
  MobileExpandIcon,
  MobileFieldCard,
  MobileCardIcon,
  MobileCardContent,
  MobileCardLabel,
  ChevronUpIcon,
  MobileConsultantContainer,
  MobileVisitsHistoryContainer,
  MobileFiltersContainer,
  MobileFilterButton,
  MobileVisitsList,
  MobileVisitCard,
  MobileVisitEyeIcon,
  MobileVisitContent,
  MobileVisitDate,
  MobileVisitRatingContainer,
  MobileVisitStars,
  MobileVisitStar,
  MobileVisitRatingNumber,
  MobileVisitRatingText,
  MobileVisitStatus,
  MobileVisitStatusBadge,
  MobileVisitWaitingText,
  MobilePaginationContainer,
  MobilePaginationLeft,
  MobilePaginationDropdown,
  MobilePaginationText,
  MobilePaginationRight,
  MobilePaginationButton,
  MobileFiltersModal,
  MobileFiltersModalHeader,
  MobileFiltersBackButton,
  MobileFiltersTitle,
  MobileFiltersClearButton,
  MobileFiltersModalContent,
  MobileFiltersModalRow,
  MobileFiltersModalLabel,
  MobileMotiveDropdown,
  MobileMotiveDropdownButton,
  MobileDateInput,
  MobileDateInputIcon,
  MobileDateInputText,
  MobileDateInputHidden,
  MobileStatusPills,
  MobileStatusPill,
  MobileRatingSliderContainer,
  MobileRatingSliderHeader,
  MobileRatingSliderControl,
  MobileRatingSliderValue,
  MobileRatingSliderTrack,
  MobileRatingSliderProgress,
  MobileRatingSliderThumb,
  MobileFiltersModalFooter,
  MobileFiltersApplyButton,
  MobileMotiveModal,
  MobileMotiveModalHeader,
  MobileMotiveModalBackButton,
  MobileMotiveModalTitle,
  MobileMotiveModalCloseButton,
  MobileMotiveModalContent,
  MobileMotiveDropdownDisplay,
  MobileMotivesList,
  MobileMotiveItem,
  MobileMotiveCheckbox,
  MobileMotiveLabel,
  MobileMotiveModalFooter,
  MobileMotiveConfirmButton
} from './MobileStyles';

import {
  BackIcon,
  Content,
  DivisionChangeName,
  HeaderContainer,
  HeaderMobileContainer,
  PageContainer,
  ConsultantDataSection,
  SectionTitle,
  ConsultantDataContainer,
  ConsultantDataItem,
  ConsultantIconContainer,
  ConsultantDataLabel,
  ConsultantDataValue,
  VisitsHistorySection,
  FiltersContainer,
  DateFilterContainer,
  DateInputDisplay,
  HiddenDateInput,
  DateIconContainer,
  ClearDateButton,
  DropdownContainer,
  DropdownButton,
  DropdownButtonText,
  DropdownMenu,
  DropdownMenuItem,
  StatusTabsContainer,
  StatusTab,
  VisitsTable,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableCell,
  StatusBadge,
  RatingBadge,
  ActionButton,
  EmptyTableMessage,
  PaginationContainer,
  PaginationLeft,
  PaginationLabel,
  PaginationDropdown,
  PaginationDropdownText,
  PaginationRight,
  PaginationButton,
  PaginationCurrentPage,
  PaginationCurrentPageText,
  ConsultantDataValueContainer,
  RatingStarsContainer,
  RatingStarImage,
  RatingText,
  WaitingText,
  PaginationDropdownMenu,
  PaginationDropdownItem,
  PaginationInfo,
  PaginationDropdownWrapper,
  LoadingDimOverlay,
  PageDimOverlay,
  MobileVisitConfirmationDiv,
  DesktopVisitConfirmationDiv,
  AvalieSpan,
  MobileWaitingTextAdjusted,
  ConfirmNote,
  TableLoadingOverlay,
  VisitsTableRelativeWrapper,
  MotivesSvgIcon,
  InfoIconButton,
  TooltipOverlay,
  TooltipModal,
  TooltipContent,
  HeaderCellContent,
  HeaderCellText
} from './styles';

export default function HistoryVisits() {
  const history = useHistory();
  const {
    showVisitDetailsModal, setShowVisitDetailsModal,
    selectedVisit, setSelectedVisit,
    whatHappenedText, setWhatHappenedText,
    showConfirmationModal, setShowConfirmationModal,
    confirmationVisit, setConfirmationVisit,
    savedConfirmationVisitForNotConfirmed, setSavedConfirmationVisitForNotConfirmed,
    showVisitNotConfirmedModal, setShowVisitNotConfirmedModal,
    deniedCommitmentId, setDeniedCommitmentId,
    showResponseRegisteredModal, setShowResponseRegisteredModal,
    showValidationModal, setShowValidationModal,
    validationAlreadyConfirmed, setValidationAlreadyConfirmed,
    showThankYouModal, setShowThankYouModal,
    feedbackType, setFeedbackType,
    showConsultantRatingModal, setShowConsultantRatingModal,
    showDaysTooltip, setShowDaysTooltip,
  } = useVisitModals();

  const {
    selectedDate, setSelectedDate,
    selectedRating, setSelectedRating,
    showRatingDropdown, setShowRatingDropdown,
    selectedStatus, setSelectedStatus,
    currentPage, setCurrentPage,
    itemsPerPage, setItemsPerPage,
    showItemsDropdown, setShowItemsDropdown,
    showMobileFilters, setShowMobileFilters,
    mobileStatus, setMobileStatus,
    showMobileRatingDropdown, setShowMobileRatingDropdown,
    mobileVisitDate, setMobileVisitDate,
    mobileRatingSlider, setMobileRatingSlider,
    showMobileMotiveModal, setShowMobileMotiveModal,
    selectedMotives, setSelectedMotives,
    tempSelectedMotives, setTempSelectedMotives,
    showMotivesList, setShowMotivesList,
    isConsultantDataExpanded, setIsConsultantDataExpanded,
    isVisitsHistoryExpanded, setIsVisitsHistoryExpanded,
  } = useVisitFilters();

  const {
    visits,
    loadingAppointments,
    loadingVisitId, setLoadingVisitId,
    tableLoading, setTableLoading,
    pageDim,
    fetchAppointments,
    handleAfterCommitmentUpdate,
    handleStartSubmit,
  } = useVisitData();

  const ratingOptions = [
    'Todas as avaliações',
    '5 estrelas',
    '4 estrelas',
    '3 estrelas',
    '2 estrelas',
    '1 estrela',
    'Sem avaliação'
  ];

  const itemsPerPageOptions = [3, 6, 9, 10, 12, 15, 20];

  const motiveOptions = [
    'Preço',
    'Estoque',
    'Treinamento',
    'Acompanhamento',
    'Dívida',
    'Performance'
  ];

  const stores = useSelector((state) => state.economicGroupReducer.stores);

  const getFilteredVisits = () => {
    let filteredData = visits;

    if (selectedStatus !== 'Todos') {
      filteredData = filteredData.filter(visit => visit.raw.StatusDaVisita === selectedStatus);
    }

    if (selectedDate && selectedDate.length === 10) {
      filteredData = filteredData.filter(visit => {
        const visitDateString = visit.date.split(' às ')[0];
        return visitDateString === selectedDate;
      });
    }

   switch (selectedRating) {
      case 'Todas as avaliações':
        break;
      case '5 estrelas':
        filteredData = filteredData.filter(visit => visit.rating === 5);
        break;
      case '4 estrelas':
        filteredData = filteredData.filter(visit => visit.rating === 4);
        break;
      case '3 estrelas':
        filteredData = filteredData.filter(visit => visit.rating === 3);
        break;
      case '2 estrelas':
        filteredData = filteredData.filter(visit => visit.rating === 2);
        break;
      case '1 estrela':
        filteredData = filteredData.filter(visit => visit.rating === 1);
        break;
      case 'Sem avaliação':
        filteredData = filteredData.filter(visit => !visit.hasRating);
        break;
    }

    return filteredData;
  };

  const getMobileFilteredVisits = () => {
    let filteredData = visits;

    if (mobileStatus !== 'Todos') {
      filteredData = filteredData.filter(visit => visit.raw.StatusDaVisita === mobileStatus);
    }

    if (selectedMotives.length > 0) {
      filteredData = filteredData.filter(visit =>
        selectedMotives.some(motive =>
          visit.subject && visit.subject.toLowerCase().includes(motive.toLowerCase())
        )
      );
    }

    if (mobileVisitDate) {
      const [fYear, fMonth, fDay] = (mobileVisitDate || '').split('-').map(n => parseInt(n, 10));
      if (fYear && fMonth && fDay) {
        filteredData = filteredData.filter(visit => {
          const visitDateString = (visit.date || '').split(' às ')[0] || '';
          const [day, month, year] = visitDateString.split('/');
          const vDay = parseInt(day, 10);
          const vMonth = parseInt(month, 10);
          const vYear = parseInt(year, 10);

          return vDay === fDay && vMonth === fMonth && vYear === fYear;
        });
      }
    }

    if (mobileRatingSlider > 0) {
      filteredData = filteredData.filter(visit => visit.rating >= mobileRatingSlider);
    }

    return filteredData;
  };

  const clearMobileFilters = () => {
    setMobileStatus('Todos');
    setMobileVisitDate('');
    setMobileRatingSlider(0);
    setSelectedMotives([]);
  };

  const applyMobileFilters = () => {
    setCurrentPage(1);
    setShowMobileFilters(false);
  };

  const handleMotiveToggle = (motive) => {
    setTempSelectedMotives(prev => {
      if (prev.includes(motive)) {
        return prev.filter(m => m !== motive);
      } else {
        return [...prev, motive];
      }
    });
  };

  const handleMotiveConfirm = () => {
    setSelectedMotives(tempSelectedMotives);
    if (tempSelectedMotives.length !== 0) {
        setShowMobileMotiveModal(false);
    }
  };

  const handleOpenMotiveModal = () => {
    setTempSelectedMotives(selectedMotives);
    setShowMotivesList(false);
    setShowMobileMotiveModal(true);
  };

  const handleToggleMotivesList = () => {
    setShowMotivesList(!showMotivesList);
  };

  const getTempMotiveDisplayText = () => {
    if (tempSelectedMotives.length === 0) {
      return 'Todos os motivos';
    } else if (tempSelectedMotives.length === 1) {
      return tempSelectedMotives[0];
    } else {
      return `${tempSelectedMotives.length} motivos selecionados`;
    }
  };

  const getMotiveDisplayText = () => {
    if (selectedMotives.length === 0) {
      return 'Todos os motivos';
    } else if (selectedMotives.length === 1) {
      return selectedMotives[0];
    } else {
      return `${selectedMotives.length} motivos selecionados`;
    }
  };

  const filteredVisits = getFilteredVisits();

  const hasMobileFilters = mobileVisitDate || selectedMotives.length > 0 || mobileRatingSlider > 0 || mobileStatus !== 'Todos';

  const mobileFilteredVisits = getMobileFilteredVisits();
  const activeFilteredVisits = hasMobileFilters ? mobileFilteredVisits : filteredVisits;

  const totalPages = Math.ceil(activeFilteredVisits.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentVisits = activeFilteredVisits.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    setShowItemsDropdown(false);
  };

  const {
    formatDateFromInput,
    formatDateToInput,
    formatDateWithPeriod,
    isWithin30Days,
  } = useDateUtilities();

  const getRemainingDays = (visit) => {
    const endDate = visit && visit.raw && (visit.raw.EndDateTime || visit.raw.EndDate);
    if (!endDate) return 0;
    const end = moment(endDate).local().startOf('day');
    const now = moment().local().startOf('day');
    const daysPassed = now.diff(end, 'days');
    const remaining = 30 - daysPassed;
    return remaining > 0 ? remaining : 0;
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedRating, selectedStatus, selectedDate]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showMobileRatingDropdown && !event.target.closest('[data-dropdown="mobile-rating"]')) {
        setShowMobileRatingDropdown(false);
      }
    };

    if (showMobileRatingDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMobileRatingDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showRatingDropdown && !event.target.closest('[data-rating-dropdown]')) {
        setShowRatingDropdown(false);
      }
      if (showItemsDropdown && !event.target.closest('[data-items-dropdown]')) {
        setShowItemsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showRatingDropdown, showItemsDropdown]);

  const handleOpenVisitDetails = async (visit) => {
    setWhatHappenedText('');
    const id = visit && (visit.id || (visit.raw && visit.raw.Id) || (visit.raw && visit.raw.commitment_id_sf));
    try {
      if (!id) {
        setSelectedVisit(visit);
        setShowVisitDetailsModal(true);
        return;
      }

      setLoadingVisitId(id);

      const res = await commitmentService.getAppointmentDetailsById(id);
      const appointment = res && res.data ? res.data : (res || {});

      const start = appointment && appointment.StartDateTime ? moment(appointment.StartDateTime).local() : null;
      const date = start ? start.format('DD/MM/YYYY [às] HH:mm') : (visit.date || '');
      const subject = appointment && (appointment.Subject || appointment.subject) ? (appointment.Subject || appointment.subject) : (visit.subject || '');
      const consultant = appointment && (appointment.OwnerName || appointment.ownerName) ? (appointment.OwnerName || appointment.ownerName) : (visit.consultant || localStorage.getItem('consultantName') || '');

      const mappedVisit = {
        ...visit,
        id: id,
        raw: { ...(visit && visit.raw ? visit.raw : {}), ...(appointment || {}) },
        date,
        subject: typeof subject === 'string' ? subject.replace(/\s*\/\s*/g, '\n') : subject,
        consultant,
        description: appointment && (appointment.Description || appointment.description) ? (appointment.Description || appointment.description) : visit.description || '',
      };

      setSelectedVisit(mappedVisit);
      setShowVisitDetailsModal(true);
    } catch (err) {
      try { toast.error('Ocorreu um erro ao carregar os detalhes da visita'); } catch (e) {}
      setSelectedVisit(null);
      setShowVisitDetailsModal(false);
    } finally {
      setLoadingVisitId(null);
    }
  };

  const handleCloseVisitDetails = () => {
    setShowVisitDetailsModal(false);
    setSelectedVisit(null);
    setWhatHappenedText('');
  };

  const handleOpenConfirmationModal = (visit) => {
    setConfirmationVisit(visit);
    setShowConfirmationModal(true);
  };

  const handleCloseConfirmationModal = async () => {
    const visit = confirmationVisit;
    if (!visit) {
      setShowConfirmationModal(false);
      setConfirmationVisit(null);
      return;
    }

    const commitmentId = visit && visit.raw && (visit.raw.commitmentId || visit.raw.Id || visit.id || visit.raw.commitment_id_sf);
    if (!commitmentId) {
      setShowConfirmationModal(false);
      setConfirmationVisit(null);
      return;
    }

    try {
      setTableLoading(true);
      const payloadToSend = {
        user_id: localStorage.getItem('userId'),
        close: true,
      };
      await commitmentService.updateCommitment(commitmentId, payloadToSend);
      await fetchAppointments();
    } catch (err) {
      console.error('Erro ao fechar VisitConfirmationModal', err);
    } finally {
      setTableLoading(false);
      setShowConfirmationModal(false);
      setConfirmationVisit(null);
    }
  };

  const handleImmediateConfirm = async () => {
    const visit = confirmationVisit;
    if (!visit) return;
    const commitmentId = visit && visit.raw && (visit.raw.commitmentId || visit.raw.Id || visit.id || visit.raw.commitment_id_sf);

    try {
      setTableLoading(true);
      const payload = {
        user_id: localStorage.getItem('userId'),
        confirm: true
      };
      await commitmentService.updateCommitment(commitmentId, payload);
      setShowConfirmationModal(false);
      setSelectedVisit(visit);
      setValidationAlreadyConfirmed(true);
      setShowValidationModal(true);
    } catch (err) {
      console.error('Erro ao confirmar visita', err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleDenyFromModal = async (bodyFromModal) => {
    const visit = confirmationVisit;
    if (!visit) return;
    const commitmentId = visit && visit.raw && (visit.raw.commitmentId || visit.raw.Id || visit.id || visit.raw.commitment_id_sf);

    try {
      setTableLoading(true);
      const payload = { finished: true, confirm: false };
      if (bodyFromModal && bodyFromModal.startDate) payload.startDate = bodyFromModal.startDate;
      if (bodyFromModal && bodyFromModal.endDate) payload.endDate = bodyFromModal.endDate;
      setSavedConfirmationVisitForNotConfirmed(confirmationVisit);
      setShowConfirmationModal(false);
      setConfirmationVisit(null);
      const forSetDenied = commitmentId;
      setDeniedCommitmentId(forSetDenied);
      await commitmentService.updateCommitment(commitmentId, payload);
      setShowVisitNotConfirmedModal(true);
    } catch (err) {
      console.error('Erro ao negar confirmação', err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleNotConfirmedSubmit = async (comment) => {
    const commitmentId = deniedCommitmentId;
    if (!commitmentId) {
      setShowVisitNotConfirmedModal(false);
      return;
    }

    const payloadToSend = {
      user_id: localStorage.getItem('userId'),
      comment: comment || ''
    };

    try {
      await commitmentService.updateCommitment(commitmentId, payloadToSend);
      setShowVisitNotConfirmedModal(false);
      setDeniedCommitmentId(null);
      await fetchAppointments();
    } catch (err) {
      console.error('Erro ao enviar comentário de não confirmado', err);
      setShowVisitNotConfirmedModal(false);
      setDeniedCommitmentId(null);
    }
  };


  const handleCloseValidationModal = async () => {
    const visit = selectedVisit;
    if (!visit) {
      setShowValidationModal(false);
      setValidationAlreadyConfirmed(false);
      return;
    }

    const commitmentId = visit && visit.raw && (visit.raw.commitmentId || visit.raw.Id || visit.id || visit.raw.commitment_id_sf);
    if (!commitmentId) {
      setShowValidationModal(false);
      setValidationAlreadyConfirmed(false);
      return;
    }

    try {
      setTableLoading(true);
      const payloadToSend = {
        user_id: localStorage.getItem('userId'),
        close: true,
      };
      await commitmentService.updateCommitment(commitmentId, payloadToSend);
      await fetchAppointments();
    } catch (err) {
      console.error('Erro ao fechar VisitValidationModal', err);
    } finally {
      setTableLoading(false);
      setShowValidationModal(false);
      setValidationAlreadyConfirmed(false);
    }
  };

  const handleValidateVisit = async (data) => {
    if (!selectedVisit) return;

    const commitmentId = selectedVisit && selectedVisit.raw && (selectedVisit.raw.commitmentId || selectedVisit.raw.Id || selectedVisit.id || selectedVisit.raw.commitment_id_sf);
    if (!commitmentId) return;

    if (validationAlreadyConfirmed) {
      setShowValidationModal(false);
      await handleAfterCommitmentUpdate();
      return;
    }

    try {
      setTableLoading(true);
      await commitmentService.updateCommitment(commitmentId, {
        finished: true,
        confirm: true,
        accordance: true
      });
      setShowValidationModal(false);
      toast.success('Obrigado pelo seu feedback! Visita validada com sucesso.');
      await handleAfterCommitmentUpdate();
    } catch (err) {
      console.error('Erro ao validar visita', err);
      toast.error('Erro ao validar a visita. Tente novamente.');
    } finally {
      setTableLoading(false);
    }
  };

  const handleValidationImmediateConfirm = async () => {
    if (!selectedVisit) return;
    const commitmentId = selectedVisit && selectedVisit.raw && (selectedVisit.raw.commitmentId || selectedVisit.raw.Id || selectedVisit.id || selectedVisit.raw.commitment_id_sf);
    if (!commitmentId) return;

    try {
      setTableLoading(true);
      await commitmentService.updateCommitment(commitmentId, {
        finished: true,
        accordance: true
      });
    } catch (err) {
      console.error('Erro no immediate confirm da validação', err);
    } finally {
      setTableLoading(false);
    }

    setFeedbackType('agreement');
    setShowValidationModal(false);
    setShowThankYouModal(true);
  };

  const handleValidationImmediateDeny = async () => {
    if (!selectedVisit) return;
    const commitmentId = selectedVisit && selectedVisit.raw && (selectedVisit.raw.commitmentId || selectedVisit.raw.Id || selectedVisit.id || selectedVisit.raw.commitment_id_sf);
    if (!commitmentId) return;

    try {
      setTableLoading(true);
      await commitmentService.updateCommitment(commitmentId, {
        finished: true,
        accordance: false
      });
    } catch (err) {
      console.error('Erro no immediate deny da validação', err);
    } finally {
      setTableLoading(false);
    }

    setFeedbackType('disagreement');
    setShowValidationModal(false);
    setShowThankYouModal(true);
  };

  const handleFeedbackSubmit = async (payload) => {
    if (!selectedVisit) return;
    const commitmentId = selectedVisit && selectedVisit.raw && (selectedVisit.raw.commitmentId || selectedVisit.raw.Id || selectedVisit.id || selectedVisit.raw.commitment_id_sf);
    if (!commitmentId) return;

    try {
      setTableLoading(true);
      await commitmentService.updateCommitment(commitmentId, payload);
    } catch (err) {
      console.error('Erro ao enviar feedback da validação', err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleRejectValidation = () => {
    console.log('Usuário não está de acordo com a validação');
    toast.info('Validação rejeitada - informações não conferem');
  };

  const handleThankYouClose = async () => {
    setShowThankYouModal(false);
    setShowValidationModal(false);
    setShowConfirmationModal(false);
    setSelectedVisit(null);
    setConfirmationVisit(null);
    setValidationAlreadyConfirmed(false);
    await fetchAppointments();
  };

  const handleThankYouBack = () => {
    setShowThankYouModal(false);
    setShowValidationModal(true);
  };

  const handleThankYouNext = (feedbackData) => {
    console.log('Feedback coletado:', feedbackData);
    if (feedbackData) {
      handleFeedbackSubmit(feedbackData);
    }
    setShowThankYouModal(false);
    setShowConsultantRatingModal(true);
  };

  const handleConsultantRatingClose = () => {
    setShowConsultantRatingModal(false);
    setShowValidationModal(false);
    setShowConfirmationModal(false);
    setShowThankYouModal(false);
    setShowResponseRegisteredModal(false);
    setSelectedVisit(null);
    setConfirmationVisit(null);
    setDeniedCommitmentId(null);
    setValidationAlreadyConfirmed(false);
    handleAfterCommitmentUpdate();
  };

  const handleConsultantRatingBack = () => {
    setShowConsultantRatingModal(false);
    setShowThankYouModal(true);
  };

  const handleConsultantRatingNext = async (ratingData) => {
    console.log('Avaliação do consultor coletada:', ratingData);
    setShowConsultantRatingModal(false);
    setShowValidationModal(false);
    setShowResponseRegisteredModal(true);
  };

  const handlePatchRating = async (ratingData) => {
    if (!selectedVisit) return;

    const commitmentId = selectedVisit && selectedVisit.raw && (selectedVisit.raw.commitmentId || selectedVisit.raw.Id || selectedVisit.id || selectedVisit.raw.commitment_id_sf);
    if (!commitmentId) return;

    const payload = {
      user_id: ratingData.user_id || localStorage.getItem('userId'),
      visit_rating: ratingData.visit_rating,
    };


    if (ratingData.hasOwnProperty('comment_rating')) {
      payload.comment_rating = ratingData.comment_rating;
    }

    try {
      await commitmentService.updateCommitment(commitmentId, payload);
    } catch (err) {
      console.warn('Erro ao enviar rating da visita', err);
    }
  };

  const handleValidationBack = () => {
    setShowValidationModal(false);
    if (confirmationVisit) {
      setShowConfirmationModal(true);
    }
  };

  return(
    <PageContainer>
      {loadingVisitId && (
        <LoadingDimOverlay aria-hidden />
      )}
      {pageDim && (
        <PageDimOverlay aria-hidden />
      )}
      <SideBar menuSelected={"Minha Conta"}>
        <DivisionChangeName>
          <HeaderContainer>
            <HeaderDesktop
              stores={stores}
            />
          </HeaderContainer>
          <HeaderMobileContainer>
            <HeaderMobile />
          </HeaderMobileContainer>
          <Content>
            <BackIcon>
              <img
                src={back}
                alt="Ícone para voltar"
                onClick={() => {
                  history.push('/minha-conta');
                }}
              />
            </BackIcon>
            {
              loadingAppointments ? (
                <Loading />
              ) : (
                <>
                  <ConsultantDataSection>
                    <SectionTitle>Dados do consultor</SectionTitle>

                    <ConsultantDataContainer>
                      <ConsultantDataItem>
                        <ConsultantIconContainer>
                          <img
                            src={accountOutline}
                            alt="Ícone do consultor"
                            width="24"
                            height="24"
                          />
                        </ConsultantIconContainer>
                        <div>
                          <ConsultantDataLabel>Nome do consultor</ConsultantDataLabel>
                          <ConsultantDataValueContainer>
                            <ConsultantDataValue>
                              {localStorage.getItem('consultantName')}
                            </ConsultantDataValue>
                            </ConsultantDataValueContainer>
                        </div>
                      </ConsultantDataItem>

                      <ConsultantDataItem>
                        <ConsultantIconContainer>
                          <img
                            src={emailSvg}
                            alt="Ícone de email"
                            width="24"
                            height="24"
                          />
                        </ConsultantIconContainer>
                        <div>
                          <ConsultantDataLabel>E-mail</ConsultantDataLabel>
                          <ConsultantDataValue>
                            {localStorage.getItem('consultantEmail')}
                          </ConsultantDataValue>
                        </div>
                      </ConsultantDataItem>

                      <ConsultantDataItem>
                        <ConsultantIconContainer>
                          <img
                            src={foneSvg}
                            alt="Ícone de telefone"
                            width="24"
                            height="24"
                          />
                        </ConsultantIconContainer>
                        <div>
                          <ConsultantDataLabel>Telefone</ConsultantDataLabel>
                          <ConsultantDataValue>
                            {mask(localStorage.getItem('consultantPhone'))}
                          </ConsultantDataValue>
                        </div>
                      </ConsultantDataItem>
                    </ConsultantDataContainer>
                  </ConsultantDataSection>

                   <MobileContainer>
                    <MobileContent>
                      <MobileConsultantContainer>
                        <MobileSectionHeader
                          isExpanded={isConsultantDataExpanded}
                          onClick={() => setIsConsultantDataExpanded(!isConsultantDataExpanded)}
                        >
                          <MobileSectionHeaderTitle>Dados do consultor</MobileSectionHeaderTitle>
                          <MobileExpandIcon isExpanded={isConsultantDataExpanded}>
                            <ChevronUpIcon />
                          </MobileExpandIcon>
                        </MobileSectionHeader>

                        <MobileExpandableContent expanded={isConsultantDataExpanded}>
                          <MobileFieldCard>
                            <MobileCardIcon>
                              <img
                                src={accountOutline}
                                alt="Ícone do consultor"
                                width="18"
                                height="18"
                              />
                            </MobileCardIcon>
                            <MobileCardContent>
                              <MobileCardLabel>{localStorage.getItem('consultantName') || 'Nome do consultor'}</MobileCardLabel>
                            </MobileCardContent>
                          </MobileFieldCard>

                          <MobileFieldCard>
                            <MobileCardIcon>
                              <img
                                src={emailSvg}
                                alt="Ícone de email"
                                width="18"
                                height="18"
                              />
                            </MobileCardIcon>
                            <MobileCardContent>
                              <MobileCardLabel>{localStorage.getItem('consultantEmail') || ''}</MobileCardLabel>
                            </MobileCardContent>
                          </MobileFieldCard>

                          <MobileFieldCard>
                            <MobileCardIcon>
                              <img
                                src={foneSvg}
                                alt="Ícone de telefone"
                                width="18"
                                height="18"
                              />
                            </MobileCardIcon>
                            <MobileCardContent>
                              <MobileCardLabel>{mask(localStorage.getItem('consultantPhone'))}</MobileCardLabel>
                            </MobileCardContent>
                          </MobileFieldCard>
                        </MobileExpandableContent>
                      </MobileConsultantContainer>

                      <MobileVisitsHistoryContainer>
                        <MobileSectionHeader
                          isExpanded={isVisitsHistoryExpanded}
                          onClick={() => setIsVisitsHistoryExpanded(!isVisitsHistoryExpanded)}
                        >
                          <MobileSectionHeaderTitle>
                            Histórico de visitas
                            <InfoIconButton onClick={(e) => {
                              e.stopPropagation();
                              setShowDaysTooltip(true);
                            }} title="Informações">
                              <img
                                src={informationCicle}
                                alt="Informação"
                                width="20"
                                height="20"
                              />
                            </InfoIconButton>
                          </MobileSectionHeaderTitle>
                          <MobileExpandIcon isExpanded={isVisitsHistoryExpanded}>
                            <ChevronUpIcon />
                          </MobileExpandIcon>
                        </MobileSectionHeader>

                        <MobileExpandableContent expanded={isVisitsHistoryExpanded}>
                          <MobileFiltersContainer>
                            <MobileFilterButton onClick={() => setShowMobileFilters(true)}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M3 6H21L15 12V20L9 16V12L3 6Z" stroke="#3D3D3D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              Filtrar
                            </MobileFilterButton>
                          </MobileFiltersContainer>

                          <MobileVisitsList>
                            {currentVisits.length > 0 ? (
                              currentVisits.map((visit) => (
                                <MobileVisitCard key={visit.id}>
                                  <MobileVisitEyeIcon onClick={() => handleOpenVisitDetails(visit)}>
                                    <img
                                      src={eyesSvg}
                                      alt="Visualizar"
                                      width="20"
                                      height="20"
                                    />
                                  </MobileVisitEyeIcon>

                                  <MobileVisitContent>
                                    <MobileVisitDate>{formatDateWithPeriod(visit.date)}</MobileVisitDate>
                                    <MobileVisitConfirmationDiv
                                      onClick={() => (
                                        visit.raw && visit.raw.resaleStatus === 'Confirmar visita'
                                        && (visit.raw.commitmentId != null)
                                      ) && handleOpenConfirmationModal(visit)}
                                      $isAgendado={visit.raw.StatusDaVisita === 'Agendado'}
                                      $isConfirmar={visit.raw.resaleStatus === 'Confirmar visita'}
                                      $confirmationStatus={visit.raw.resaleStatus}
                                    >
                                      {(visit.raw && visit.raw.resaleStatus === 'Confirmar visita' && visit.raw.commitmentId == null) ? (
                                        <WaitingText>-----</WaitingText>
                                        ) : (
                                        <>
                                          {visit.raw.resaleStatus || visit.subject}
                                          {(visit.raw && visit.raw.resaleStatus === 'Confirmar visita' && visit.raw.commitmentId != null) && (() => {
                                            const remaining = getRemainingDays(visit);
                                            return remaining > 0 ? (
                                              <ConfirmNote>Avaliar em até {remaining} dia{remaining > 1 ? 's' : ''}</ConfirmNote>
                                            ) : null;
                                          })()}
                                        </>
                                      )}
                                    </MobileVisitConfirmationDiv>

                                    <MobileVisitRatingContainer>
                                      {visit.hasRating ? (
                                        <>
                                          <MobileVisitStars>
                                            {[1,2,3,4,5].map((star) => (
                                              <MobileVisitStar
                                                key={star}
                                                src={starSvg}
                                                alt="Estrela"
                                                isActive={star <= visit.rating}
                                              />
                                            ))}
                                          </MobileVisitStars>
                                          <MobileVisitRatingNumber>
                                            {visit.rating}
                                          </MobileVisitRatingNumber>
                                        </>
                                      ) : visit.raw.StatusDaVisita === 'Realizado' ? (
                                        <MobileVisitRatingText>
                                          {(visit.raw && visit.raw.resaleStatus === 'Confirmar visita') ? (
                                            <MobileWaitingTextAdjusted>-----</MobileWaitingTextAdjusted>
                                          ) : (
                                            (visit.raw && (visit.raw.commitmentId != null))
                                            && (visit.raw.visitRating == null && visit.rating == null)
                                            && (visit.raw.finished === true)
                                            && (visit.raw.confirm !== false)
                                            && isWithin30Days(visit.raw.EndDateTime)
                                          ) ? (
                                            <AvalieSpan onClick={() => handleOpenVisitDetails(visit)}>Avalie</AvalieSpan>
                                          ) : (
                                            <MobileWaitingTextAdjusted>-----</MobileWaitingTextAdjusted>
                                          )}
                                        </MobileVisitRatingText>
                                      ) : (
                                        <MobileVisitWaitingText>
                                          -----
                                        </MobileVisitWaitingText>
                                      )}
                                    </MobileVisitRatingContainer>
                                  </MobileVisitContent>

                                  <MobileVisitStatus>
                                    <MobileVisitStatusBadge status={visit.raw.StatusDaVisita}>
                                      {visit.raw.StatusDaVisita}
                                    </MobileVisitStatusBadge>
                                  </MobileVisitStatus>
                                </MobileVisitCard>
                              ))
                            ) : (
                              <MobileVisitCard>
                                <MobileVisitContent>
                                  <MobileVisitWaitingText>
                                    Nenhuma visita encontrada para o filtro selecionado.
                                  </MobileVisitWaitingText>
                                </MobileVisitContent>
                              </MobileVisitCard>
                            )}
                          </MobileVisitsList>
                        </MobileExpandableContent>
                      </MobileVisitsHistoryContainer>

                      <MobilePaginationContainer>
                        <MobilePaginationLeft>
                          <MobilePaginationDropdown
                            value={currentPage}
                            onChange={(e) => handlePageChange(parseInt(e.target.value))}
                          >
                            {Array.from({length: totalPages}, (_, i) => i + 1).map(page => (
                              <option key={page} value={page}>{page}</option>
                            ))}
                          </MobilePaginationDropdown>
                          <MobilePaginationText>
                            de {totalPages} página{totalPages !== 1 ? 's' : ''}
                          </MobilePaginationText>
                        </MobilePaginationLeft>

                        <MobilePaginationRight>
                          <MobilePaginationButton
                            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                            disabled={currentPage <= 1}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                              <path d="M15 18L9 12L15 6" stroke={currentPage > 1 ? "#3D3D3D" : "#CBCBCB"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </MobilePaginationButton>

                          <MobilePaginationButton
                            onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                            disabled={currentPage >= totalPages}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                              <path d="M9 18L15 12L9 6" stroke={currentPage < totalPages ? "#3D3D3D" : "#CBCBCB"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </MobilePaginationButton>
                        </MobilePaginationRight>
                      </MobilePaginationContainer>
                    </MobileContent>
                  </MobileContainer>
                  <VisitsHistorySection>
                    <SectionTitle>Histórico de visitas</SectionTitle>

                    <FiltersContainer>
                      <DateFilterContainer
                        onClick={() => {
                          const hiddenInput = document.getElementById('hidden-date-input');
                          if (hiddenInput) {
                            hiddenInput.showPicker();
                          }
                        }}
                      >
                        <DateIconContainer>
                          <img
                            src={dateSvg}
                            alt="Ícone de data"
                            width="20"
                            height="20"
                          />
                        </DateIconContainer>

                        <DateInputDisplay hasValue={selectedDate !== ''}>
                          {selectedDate || "Data da visita"}
                        </DateInputDisplay>

                        <HiddenDateInput
                          id="hidden-date-input"
                          type="date"
                          value={formatDateToInput(selectedDate)}
                          max={new Date().toISOString().split('T')[0]}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue) {
                              const formattedDate = formatDateFromInput(inputValue);
                              setSelectedDate(formattedDate);
                            } else {
                              setSelectedDate('');
                            }
                          }}
                        />

                        {selectedDate && (
                          <ClearDateButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedDate('');
                              const hiddenInput = document.getElementById('hidden-date-input');
                              if (hiddenInput) {
                                hiddenInput.value = '';
                              }
                            }}
                            title="Limpar filtro de data"
                          >
                            ×
                          </ClearDateButton>
                        )}
                      </DateFilterContainer>

                      <DropdownContainer data-rating-dropdown>
                        <DropdownButton
                          onClick={() => setShowRatingDropdown(!showRatingDropdown)}
                        >
                          <DropdownButtonText>{selectedRating}</DropdownButtonText>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" fill="#CBCBCB"/>
                          </svg>
                        </DropdownButton>

                        {showRatingDropdown && (
                          <DropdownMenu>
                            {ratingOptions.map((option, index) => (
                              <DropdownMenuItem
                                key={option}
                                isSelected={selectedRating === option}
                                showBorder={index < ratingOptions.length - 1}
                                onClick={() => {
                                  setSelectedRating(option);
                                  setShowRatingDropdown(false);
                                }}
                              >
                                {option}
                              </DropdownMenuItem>
                            ))}
                          </DropdownMenu>
                        )}
                      </DropdownContainer>
                     </FiltersContainer>
                    <StatusTabsContainer>
                      {[
                        'Todos',
                        'Agendado',
                        'Realizado',
                        'Cancelado'
                      ].map((status, index, array) => (
                        <StatusTab
                          key={status}
                          isSelected={selectedStatus === status}
                          position={
                            index === 0 ? 'first' :
                            index === array.length - 1 ? 'last' : 'middle'
                          }
                          onClick={() => setSelectedStatus(status)}
                        >
                          {status}
                        </StatusTab>
                      ))}
                    </StatusTabsContainer>

                    <VisitsTableRelativeWrapper>
                    <VisitsTable>
                      <TableHeader>
                        <TableHeaderCell width="170px">
                          Status da visita
                        </TableHeaderCell>
                        <TableHeaderCell width="190px">Data da visita</TableHeaderCell>
                        <TableHeaderCell width="216px">
                          <HeaderCellContent>
                            <HeaderCellText>Confirmação da visita</HeaderCellText>

                          </HeaderCellContent>
                          <InfoIconButton onClick={() => setShowDaysTooltip(true)} title="Informações">
                            <img
                              src={informationCicle}
                              alt="Informação"
                              width="20"
                              height="20"
                            />
                          </InfoIconButton>
                        </TableHeaderCell>
                        <TableHeaderCell width="220px">
                          Avaliação
                        </TableHeaderCell>
                        <TableHeaderCell width="124px" textAlign="center">
                          Ações
                        </TableHeaderCell>
                      </TableHeader>

                      {currentVisits.length > 0 ? (
                        currentVisits.map((visit, index) => {
                          return (
                          <TableRow
                            key={visit.id}
                            showBorder={index < currentVisits.length - 1}
                            isLast={index === currentVisits.length - 1}
                          >
                            <TableCell width="170px">
                              <StatusBadge status={visit.raw.StatusDaVisita}>
                                {visit.raw.StatusDaVisita}
                              </StatusBadge>
                            </TableCell>
                            <TableCell width="190px">
                              {formatDateWithPeriod(visit.date)}
                            </TableCell>
                            <TableCell width="226px" whiteSpace="pre-line" component="td">
                              <DesktopVisitConfirmationDiv
                                onClick={() => (
                                  visit.raw && visit.raw.resaleStatus === 'Confirmar visita'
                                  && (visit.raw.commitmentId != null)
                                ) && handleOpenConfirmationModal(visit)}
                                $isAgendado={visit.raw.StatusDaVisita === 'Agendado'}
                                $isConfirmar={visit.raw.resaleStatus === 'Confirmar visita'}
                                $confirmationStatus={visit.raw.resaleStatus}
                              >
                                {(visit.raw && visit.raw.resaleStatus === 'Confirmar visita' && visit.raw.commitmentId == null) ? (
                                  <WaitingText>-----</WaitingText>
                                  ) : (
                                    <>
                                      {visit.raw.resaleStatus || visit.subject}
                                      {(visit.raw && visit.raw.resaleStatus === 'Confirmar visita' && visit.raw.commitmentId != null) && (() => {
                                        const remaining = getRemainingDays(visit);
                                        return remaining > 0 ? (
                                          <ConfirmNote>Avaliar em até {remaining} dia{remaining > 1 ? 's' : ''}</ConfirmNote>
                                        ) : null;
                                      })()}
                                    </>
                                )}
                              </DesktopVisitConfirmationDiv>
                            </TableCell>
                            <TableCell width="220px" gap="12px">
                              {visit.hasRating ? (
                                <>
                                  <RatingStarsContainer>
                                    {[1,2,3,4,5].map((star) => (
                                      <RatingStarImage
                                        key={star}
                                        src={starSvg}
                                        alt="Estrela"
                                        width="16"
                                        height="15"
                                        isActive={star <= visit.rating}
                                      />
                                    ))}
                                  </RatingStarsContainer>
                                  <RatingBadge>
                                    {visit.rating}
                                  </RatingBadge>
                                </>
                              ) : visit.raw.StatusDaVisita === 'Realizado' ? (
                                <RatingText style={{ cursor: (visit.raw && (visit.raw.commitmentId != null) && visit.raw.finished === true && visit.raw.confirm !== false && (visit.raw.visitRating == null && visit.rating == null)) ? 'pointer' : 'default' }}>
                                  {(visit.raw && visit.raw.resaleStatus === 'Confirmar visita') ? (
                                    <WaitingText>-----</WaitingText>
                                  ) : (
                                    visit.raw
                                    && (visit.raw.commitmentId != null)
                                    && (visit.raw.visitRating == null && visit.rating == null)
                                    && (visit.raw.finished === true)
                                    && (visit.raw.confirm !== false)
                                    && isWithin30Days(visit.raw.EndDateTime)
                                  ) ? (
                                    <AvalieSpan onClick={() => handleOpenVisitDetails(visit)}>Avalie</AvalieSpan>
                                  ) : (
                                    <WaitingText>-----</WaitingText>
                                  )}
                                </RatingText>
                              ) : (
                                <>
                                  <WaitingText>
                                    -----
                                  </WaitingText>
                                </>
                              )}
                            </TableCell>
                            <TableCell width="124px">
                              <ActionButton onClick={() => handleOpenVisitDetails(visit)}>
                                <img
                                  src={eyesSvg}
                                  alt="Visualizar"
                                  width="20"
                                  height="20"
                                />
                              </ActionButton>
                            </TableCell>
                          </TableRow>
                          );
                        })
                      ) : (
                        <EmptyTableMessage>
                          Nenhuma visita encontrada para o filtro selecionado.
                        </EmptyTableMessage>
                      )}
                    </VisitsTable>

                    {tableLoading && (
                      <TableLoadingOverlay aria-hidden>
                        <Loading />
                      </TableLoadingOverlay>
                    )}
                  </VisitsTableRelativeWrapper>

                    <PaginationContainer>
                      <PaginationLeft>
                        <PaginationLabel>Itens por página:</PaginationLabel>
                        <PaginationDropdownWrapper data-items-dropdown>
                          <PaginationDropdown
                            onClick={() => setShowItemsDropdown(!showItemsDropdown)}
                          >
                            <PaginationDropdownText>{itemsPerPage}</PaginationDropdownText>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" fill="#000000"/>
                            </svg>
                          </PaginationDropdown>

                          {showItemsDropdown && (
                            <PaginationDropdownMenu>
                              {itemsPerPageOptions.map((option, index) => (
                                <PaginationDropdownItem
                                  key={option}
                                  isSelected={itemsPerPage === option}
                                  showBorder={index < itemsPerPageOptions.length - 1}
                                  onClick={() => handleItemsPerPageChange(option)}
                                >
                                  {option}
                                </PaginationDropdownItem>
                              ))}
                            </PaginationDropdownMenu>
                          )}
                        </PaginationDropdownWrapper>
                        <PaginationInfo>{startIndex + 1}-{Math.min(endIndex, filteredVisits.length)} de {filteredVisits.length} itens</PaginationInfo>
                      </PaginationLeft>

                      <PaginationRight>
                        <PaginationButton
                          onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                          disabled={currentPage <= 1}
                        >
                          <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                            <path d="M27.5 14.67L21.17 21L27.5 27.33L25.33 29.5L16.83 21L25.33 12.5L27.5 14.67Z" fill={currentPage > 1 ? "#3D3D3D" : "#CBCBCB"}/>
                          </svg>
                        </PaginationButton>
                        <PaginationCurrentPage>
                          <PaginationCurrentPageText>{currentPage}</PaginationCurrentPageText>
                        </PaginationCurrentPage>
                        <PaginationInfo>de {totalPages} página{totalPages !== 1 ? 's' : ''}</PaginationInfo>
                        <PaginationButton
                          onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                          disabled={currentPage >= totalPages}
                        >
                          <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                            <path d="M16.5 14.67L22.83 21L16.5 27.33L18.67 29.5L27.17 21L18.67 12.5L16.5 14.67Z" fill={currentPage < totalPages ? "#3D3D3D" : "#CBCBCB"}/>
                          </svg>
                        </PaginationButton>
                      </PaginationRight>
                    </PaginationContainer>
                  </VisitsHistorySection>

                  <MobileFiltersModal show={showMobileFilters}>
                    <MobileFiltersModalHeader>
                      <MobileFiltersBackButton onClick={() => setShowMobileFilters(false)}>
                        <img
                        src={back}
                        alt="Ícone para voltar"
                        />
                        Voltar
                      </MobileFiltersBackButton>
                      <MobileFiltersTitle>Filtrar por</MobileFiltersTitle>
                      <MobileFiltersClearButton onClick={clearMobileFilters}>
                        Limpar
                      </MobileFiltersClearButton>
                    </MobileFiltersModalHeader>

                    <MobileFiltersModalContent>
                      <MobileFiltersModalRow>
                        <MobileFiltersModalLabel>Motivo da visita</MobileFiltersModalLabel>
                        <MobileMotiveDropdown>
                          <MobileMotiveDropdownButton
                            onClick={handleOpenMotiveModal}
                          >
                            {getMotiveDisplayText()}
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                              <path d="M6 9L12 15L18 9" stroke="#3D3D3D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </MobileMotiveDropdownButton>
                        </MobileMotiveDropdown>
                      </MobileFiltersModalRow>

                      <MobileFiltersModalRow>
                        <MobileFiltersModalLabel>Data da visita</MobileFiltersModalLabel>
                        <MobileDateInput onClick={() => {
                          const hiddenInput = document.getElementById('mobile-date-input');
                          if (hiddenInput) hiddenInput.showPicker();
                        }}>

                        <MobileDateInputText hasValue={!!mobileVisitDate}>
                          {mobileVisitDate ? formatDateFromInput(mobileVisitDate) : 'dd/mm/aaaa'}
                        </MobileDateInputText>
                        <MobileDateInputHidden
                          id="mobile-date-input"
                          type="date"
                          value={mobileVisitDate}
                          onChange={(e) => setMobileVisitDate(e.target.value)}
                        />
                        <MobileDateInputIcon>
                          <img
                            src={dateSvg}
                            alt="Ícone de data"
                            width="20"
                            height="20"
                          />
                        </MobileDateInputIcon>
                        </MobileDateInput>
                      </MobileFiltersModalRow>

                      <MobileFiltersModalRow>
                        <MobileFiltersModalLabel>Status</MobileFiltersModalLabel>
                        <MobileStatusPills>
                          {[
                            { value: 'Todos', label: 'Todos' },
                            { value: 'Realizado', label: 'Realizado' },
                            { value: 'Agendado', label: 'Agendado' },
                            { value: 'Cancelado', label: 'Cancelado' }
                          ].map((status) => (
                            <MobileStatusPill
                              key={status.value}
                              isSelected={mobileStatus === status.value}
                              onClick={() => setMobileStatus(status.value)}
                            >
                              {status.label}
                            </MobileStatusPill>
                          ))}
                        </MobileStatusPills>
                      </MobileFiltersModalRow>

                      <MobileFiltersModalRow>
                        <MobileFiltersModalLabel>Nota da avaliação</MobileFiltersModalLabel>
                        <MobileRatingSliderContainer>
                          <MobileRatingSliderHeader>
                            <MobileRatingSliderControl
                              onClick={() => setMobileRatingSlider(Math.max(0, mobileRatingSlider - 1))}
                              disabled={mobileRatingSlider === 0}
                            >
                              −
                            </MobileRatingSliderControl>
                            <MobileRatingSliderValue>
                              <MobileVisitStar
                                key={1}
                                src={starSvg}
                                alt="Estrela"
                                isActive
                              />
                              <span>{mobileRatingSlider === 0 ? 'Qualquer' : `${mobileRatingSlider} estrela${mobileRatingSlider > 1 ? 's' : ''}`}</span>
                            </MobileRatingSliderValue>
                            <MobileRatingSliderControl
                              onClick={() => setMobileRatingSlider(Math.min(5, mobileRatingSlider + 1))}
                              disabled={mobileRatingSlider === 5}
                            >
                              +
                            </MobileRatingSliderControl>
                          </MobileRatingSliderHeader>
                          <MobileRatingSliderTrack>
                            <MobileRatingSliderProgress progress={(mobileRatingSlider / 5) * 100} />
                            <MobileRatingSliderThumb position={(mobileRatingSlider / 5) * 100} />
                          </MobileRatingSliderTrack>
                        </MobileRatingSliderContainer>
                      </MobileFiltersModalRow>
                    </MobileFiltersModalContent>

                    <MobileFiltersModalFooter>
                      <MobileFiltersApplyButton
                        onClick={applyMobileFilters}
                      >
                        Filtrar
                      </MobileFiltersApplyButton>
                    </MobileFiltersModalFooter>
                  </MobileFiltersModal>

                  <MobileMotiveModal show={showMobileMotiveModal}>
                    <MobileMotiveModalHeader>
                      <MobileMotiveModalBackButton onClick={() => setShowMobileMotiveModal(false)}>
                       <img
                        src={back}
                        alt="Ícone para voltar"
                        />
                        Voltar
                      </MobileMotiveModalBackButton>
                      <MobileMotiveModalTitle>Motivo da visita</MobileMotiveModalTitle>
                      <MobileMotiveModalCloseButton onClick={() => setShowMobileMotiveModal(false)}>
                        ✕
                      </MobileMotiveModalCloseButton>
                    </MobileMotiveModalHeader>

                    <MobileMotiveModalContent>
                      <MobileMotiveDropdownDisplay onClick={handleToggleMotivesList}>
                        {getTempMotiveDisplayText()}
                        <MotivesSvgIcon width="20" height="20" viewBox="0 0 24 24" fill="none" $isOpen={showMotivesList}>
                          <path d="M6 9L12 15L18 9" stroke="#3D3D3D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </MotivesSvgIcon>
                      </MobileMotiveDropdownDisplay>

                      {showMotivesList && (
                        <MobileMotivesList>
                          {motiveOptions.map((motive) => (
                            <MobileMotiveItem
                              key={motive}
                              onClick={() => handleMotiveToggle(motive)}
                            >
                              <MobileMotiveCheckbox
                                type="checkbox"
                                checked={tempSelectedMotives.includes(motive)}
                                onChange={() => handleMotiveToggle(motive)}
                              />
                              <MobileMotiveLabel>
                                {motive}
                              </MobileMotiveLabel>
                            </MobileMotiveItem>
                          ))}
                        </MobileMotivesList>
                      )}
                    </MobileMotiveModalContent>

                    <MobileMotiveModalFooter>
                      <MobileMotiveConfirmButton onClick={handleMotiveConfirm}>
                        Confirmar
                      </MobileMotiveConfirmButton>
                    </MobileMotiveModalFooter>
                  </MobileMotiveModal>

                    <VisitConfirmationModal
                      isOpen={showConfirmationModal}
                      onClose={handleCloseConfirmationModal}
                      consultantName={confirmationVisit?.consultant || confirmationVisit?.raw?.OwnerName || ''}
                      visitDate={confirmationVisit?.raw?.StartDateTime || confirmationVisit?.date}
                      visitTime={confirmationVisit?.raw?.StartDateTime || confirmationVisit?.date}
                      onImmediateConfirm={handleImmediateConfirm}
                      onDeny={handleDenyFromModal}
                    />

                    <VisitDetailsModal
                      isOpen={showVisitDetailsModal}
                      onClose={handleCloseVisitDetails}
                      visit={selectedVisit}
                      whatHappenedText={whatHappenedText}
                      setWhatHappenedText={setWhatHappenedText}
                      onAfterUpdate={handleAfterCommitmentUpdate}
                      onStartSubmit={handleStartSubmit}
                    />

                    <VisitValidationModal
                      isOpen={showValidationModal}
                      onClose={handleCloseValidationModal}
                      onBack={handleValidationBack}
                      consultantName={selectedVisit?.consultant || ''}
                      visitDate={selectedVisit?.date ? (selectedVisit.date.split(' às ')[0] || '') : ''}
                      visitTime={selectedVisit?.date ? (selectedVisit.date.split(' às ')[1] || '') : ''}
                      appointmentId={selectedVisit && (selectedVisit.id || (selectedVisit.raw && (selectedVisit.raw.Id || selectedVisit.raw.commitmentId || selectedVisit.raw.commitment_id_sf)))}
                      initialConfirmed={validationAlreadyConfirmed}
                      onConfirm={handleValidateVisit}
                      onDeny={handleRejectValidation}
                      onImmediateConfirm={handleValidationImmediateConfirm}
                      onImmediateDeny={handleValidationImmediateDeny}
                      onFeedbackSubmit={handleFeedbackSubmit}
                      onPatchRating={handlePatchRating}
                      showFeedbackModal={showThankYouModal}
                      setShowFeedbackModal={setShowThankYouModal}
                      feedbackType={feedbackType}
                      setFeedbackType={setFeedbackType}
                      showConsultantRatingModal={showConsultantRatingModal}
                      setShowConsultantRatingModal={setShowConsultantRatingModal}
                    />

                    <VisitNotConfirmedModal
                      isOpen={showVisitNotConfirmedModal}
                      onClose={() => { setShowVisitNotConfirmedModal(false); setDeniedCommitmentId(null); }}
                      onBack={() => { setShowVisitNotConfirmedModal(false); setConfirmationVisit(savedConfirmationVisitForNotConfirmed); setShowConfirmationModal(true); }}
                      onSubmit={handleNotConfirmedSubmit}
                    />

                    <ResponseRegisteredModal
                      isOpen={showResponseRegisteredModal}
                      source="HistoryVisits"
                      onClose={() => {
                        setShowResponseRegisteredModal(false);
                        setShowThankYouModal(false);
                        setShowConsultantRatingModal(false);
                        setShowValidationModal(false);
                        setShowConfirmationModal(false);
                        setSelectedVisit(null);
                        setConfirmationVisit(null);
                        setDeniedCommitmentId(null);
                        setValidationAlreadyConfirmed(false);
                        handleAfterCommitmentUpdate();
                      }}
                    />

                  <FeedbackModal
                    type={feedbackType}
                    isOpen={showThankYouModal}
                    onClose={handleThankYouClose}
                    onBack={handleThankYouBack}
                    onNext={handleThankYouNext}
                  />

                  <ConsultantRatingModal
                    isOpen={showConsultantRatingModal}
                    onClose={handleConsultantRatingClose}
                    onBack={handleConsultantRatingBack}
                    onNext={handleConsultantRatingNext}
                    onPatchRating={handlePatchRating}
                  />

                  {showDaysTooltip && (
                    <TooltipOverlay onClick={() => setShowDaysTooltip(false)}>
                      <TooltipModal onClick={(e) => e.stopPropagation()}>
                        <TooltipContent>
                          Você pode avaliar sua visita em até 30 dias a partir da data da visita.
                        </TooltipContent>
                      </TooltipModal>
                    </TooltipOverlay>
                  )}
                </>
              )
            }
          </Content>
        </DivisionChangeName>
      </SideBar>
    </PageContainer>
  );
}
